export const Play2Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      width="1em"
      height="1em"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_302_5275)">
        <path d="M24.7405 6.88305C24.7405 6.88305 24.5065 5.11755 23.7872 4.34055C22.8745 3.32205 21.8515 3.31605 21.3827 3.2583C18.0242 2.99805 12.9857 2.99805 12.9857 2.99805H12.9745C12.9745 2.99805 7.93672 2.99805 4.57897 3.2583C4.10947 3.3153 3.08797 3.3213 2.17447 4.34055C1.45522 5.11755 1.22047 6.88305 1.22047 6.88305C1.22047 6.88305 0.980469 8.95455 0.980469 11.026V12.9678C0.980469 15.0408 1.22047 17.1115 1.22047 17.1115C1.22047 17.1115 1.45447 18.8763 2.17372 19.6518C3.08722 20.6703 4.28572 20.6395 4.81972 20.746C6.73972 20.9425 12.9805 21.0033 12.9805 21.0033C12.9805 21.0033 18.0235 20.9943 21.3827 20.737C21.8515 20.677 22.8745 20.671 23.7872 19.6518C24.5057 18.8763 24.7405 17.1115 24.7405 17.1115C24.7405 17.1115 24.9805 15.04 24.9805 12.9678V11.026C24.9805 8.95455 24.7405 6.88305 24.7405 6.88305ZM9.98347 16.5018V7.4988L17.4857 12.0003L9.98347 16.5018Z" />
      </g>
      <defs>
        <clipPath id="clip0_302_5275">
          <rect width="24" height="24" fill="white" transform="translate(0.980469)" />
        </clipPath>
      </defs>
    </svg>
  );
};
